import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { RESET_AUTH_MESSAGES_AND_ERRORS } from "../../../redux/actions/actionTypes";
import { Modal } from "react-bootstrap";
import LoginForm from "./LoginForm";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Login = ({ isSideBar }) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();
    const [formMode, setFormMode] = useState("login");

    const closeModal = () => {
        setShowModal(false);
        setFormMode("login");
        dispatch({ type: RESET_AUTH_MESSAGES_AND_ERRORS });
    };

    const handleLoginClick = () => {
        const token = localStorage.getItem("token");
        if (token) {
            window.location.href = `${process.env.REACT_APP_AGENT_BASEURL}/chat`;
        } else {
            setShowModal(true);
        }
    };

    return (
        <React.Fragment>
            {isSideBar ? (
                <li className="nav-item">
                    <Link
                        className="nav-link link"
                        onClick={() => {
                            handleLoginClick();
                            document.getElementById("btn_sideNavClose").click();
                            ReactGA.event({
                                category: "log_in_sidebar_click",
                                action: "log_in_sidebar_click",
                                label: "log_in_sidebar_click",
                                value: 1,
                            });
                        }}
                        to={"#login"}
                        id="btn_sideNavLogin"
                    >
                        {t("navbar.login")}
                    </Link>
                </li>
            ) : (
                <button
                    className="btn nav-btn-login"
                    onClick={handleLoginClick}
                >
                    {t("navbar.login")}
                </button>
            )}

            <Modal
                show={showModal}
                onHide={closeModal}
                aria-labelledby="developer-register-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="developer-register-modal-title-vcenter">
                        {(formMode === "register" || formMode === "registerSuccess")
                            ? t("navbar.register")
                            : formMode === "forgot"
                                ? t("navbar.forgot")
                                : t("navbar.login")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <LoginForm formMode={formMode} setFormMode={setFormMode} />
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
};

export default Login;